import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-edit",
  "use": "icon-icon-edit-usage",
  "viewBox": "0 0 12 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 11\" id=\"icon-icon-edit\">\r\n  <defs>\r\n    <style>\r\n      #icon-icon-edit .cls-1 {\r\n        fill: #459fff;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"icon-icon-edit_联合_114\" data-name=\"联合 114\" class=\"cls-1\" d=\"M0,11V9.21H12V11ZM3.037,5.463,8.445,0l1.5,1.515L4.537,6.978l-1.729.236Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-edit.svg
// module id = IdwL
// module chunks = 3